"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const DoorSlideTrackSnapping_1 = __importDefault(require("./DoorSlideTrackSnapping"));
// eslint-disable-next-line import/no-cycle
const GasketSnapping_1 = __importDefault(require("./GasketSnapping"));
// eslint-disable-next-line import/no-cycle
const TSlotCoverSnapping_1 = __importDefault(require("./TSlotCoverSnapping"));
class SlotCoverSnappingFactory {
    static getCoverSnapping(viewer, coverComponent) {
        const { componentType } = coverComponent.partDetails;
        switch (componentType) {
            case 'T-slot cover':
                return new TSlotCoverSnapping_1.default(viewer, coverComponent);
            case 'Door slide track':
                return new DoorSlideTrackSnapping_1.default(viewer, coverComponent);
            case 'Panel gasket':
                return new GasketSnapping_1.default(viewer, coverComponent);
            default:
                throw new Error('Non-covering component type');
        }
    }
}
exports.default = SlotCoverSnappingFactory;
